
import request from '@/shared/apis'

// URL helper functions
const getBaseApiUrl = () => {
  return '/evaluations/templates';
};

const getTemplateApiUrl = (id) => {
  return `${getBaseApiUrl()}/${id}`;
};

export const getTemplatesApi = async () => {
  return await request.get(getBaseApiUrl());
};

export const getActiveTemplatesApi = async () => {
  return await request.get(`${getBaseApiUrl()}/active`);
};

export const getTemplateByIdApi = async (id) => {
  return await request.get(getTemplateApiUrl(id));
};

export const createTemplateApi = async (data) => {
  return await request.post(getBaseApiUrl(), data);
};

export const updateTemplateApi = async (id, data) => {
  return await request.put(getTemplateApiUrl(id), data);
};

export const deleteTemplateApi = async (id) => {
  return await request.delete(getTemplateApiUrl(id));
};

export const cloneTemplateApi = async (id, newVersion, programmeTypeId = null) => {
  let url = `${getTemplateApiUrl(id)}/clone?newVersion=${newVersion}`;
  if (programmeTypeId) {
    url += `&targetProgrammeTypeId=${programmeTypeId}`;
  }
  return await request.post(url);
};

export const exportTemplateApi = async (id) => {
  return await request.get(`${getTemplateApiUrl(id)}/export`, {
    responseType: 'blob'
  });
};

export const importTemplateApi = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return await request.post(`${getBaseApiUrl()}/import`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};
